import React from 'react'
import {createRoot} from 'react-dom/client'
import 'reflect-metadata'

import '@/constants'
import {getUserLanguage, getAntdLocale, setupMomentLocale} from '@/services/lang'
import '~/assets/styles/main.scss'
import '~/assets/styles/override.scss'

// Import i18n configuration
import {initI18nextPromise} from './i18n'

import {App} from './App'

const container = document.getElementById('app-content')
const root = createRoot(container!)

const renderApp = async () => {
    const lang = getUserLanguage()
    const antdLocale = await getAntdLocale(lang)
    await setupMomentLocale(lang)
    await initI18nextPromise
    root.render(<App locale={antdLocale} />)
}

renderApp()

if (module.hot) {
    module.hot.accept('./App', () => {
        console.log('🔥 Hot reloading App component')
        renderApp()
    })

    // Also accept changes to your main SCSS file
    module.hot.accept('~/assets/styles/main.scss', () => {
        console.log('🎨 Hot reloading styles')
        // CSS will be automatically updated by style-loader
    })

    // Accept changes to constants
    module.hot.accept('@/constants', () => {
        console.log('⚙️ Hot reloading constants')
        renderApp()
    })
}
